import { useNavigate } from 'react-router-dom';

export default function ServiceCategories() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-hand-heart-line',
      title: '네일아트',
      color: 'from-rose-400 to-pink-400',
      path: '/service/nail#designs'
    },
    {
      icon: 'ri-eye-line',
      title: '속눈썹',
      color: 'from-pink-400 to-purple-400',
      path: '/service/lash#designs'
    },
    {
      icon: 'ri-scissors-line',
      title: '왁싱',
      color: 'from-purple-400 to-indigo-400',
      path: '/service/waxing#designs'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '피부관리',
      color: 'from-rose-300 to-pink-300',
      path: '/service/skincare#designs'
    },
    {
      icon: 'ri-scissors-2-line',
      title: '헤어',
      color: 'from-pink-300 to-purple-300',
      path: '/service/hair#designs'
    },
    {
      icon: 'ri-palette-line',
      title: '메이크업',
      color: 'from-purple-300 to-rose-300',
      path: '/service/makeup#designs'
    }
  ];

  const handleNavigate = (path: string) => {
    const [pathname, hash] = path.split('#');
    navigate(pathname);
    
    // 페이지 이동 후 앵커로 스크롤
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  return (
    <section id="services" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Services
          </h2>
          <p className="text-base text-gray-600">나에게 맞는 뷰티 서비스를 선택하세요</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleNavigate(service.path)}
              className="group relative bg-white rounded-2xl p-6 md:p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden hover:-translate-y-2"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
              
              <div className="relative flex flex-col items-center text-center">
                <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${service.color} mb-3 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg`}>
                  <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-base md:text-lg font-medium text-gray-800 group-hover:text-rose-500 transition-colors duration-300">{service.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
